import { cssVar } from '@chakra-ui/react';

const $fg = cssVar('badge-color');

const baseStyle = {
  px: 1.5,
  py: 1,
  fontSize: 'sm',
  fontWeight: 'semibold',
  lineHeight: 'xs',
  borderRadius: 'base',
  textTransform: 'none',
};

const variantSolid = {
  [$fg.variable]: 'colors.white',
  bg: `blackAlpha.600`,
  color: $fg.reference,
};

const variantSubtle = {
  bg: 'blackAlpha.80',
  color: 'text.tertiary',
};

const variantOutline = {
  [$fg.variable]: 'colors.stroke.grey',
  color: `text.tertiary`,
  boxShadow: `inset 0 0 0px 1px ${$fg.reference}`,
};

const variants = {
  solid: variantSolid,
  subtle: variantSubtle,
  outline: variantOutline,
};

export const Badge = {
  baseStyle,
  variants,
  defaultProps: {
    variant: 'subtle',
    colorScheme: 'gray',
  },
};
